import React from 'react';
import {FormControl, FormGroup, HelpBlock} from 'react-bootstrap';

const TextInput = (props) => {

    let validationState = null;
    let helpBlock;
    const type = props.type || props.password ? "password" : "text";

    if (props.meta.touched && props.meta.error !== undefined) {
        validationState = 'error'
        helpBlock = <HelpBlock>{props.meta.error}</HelpBlock>
    }

    const input = props.input
    input.readOnly = props.disabled

    return (
        <FormGroup readOnly validationState={validationState}>
            {props.label && <label>{props.label}</label>}
            <FormControl  {...input} type={type} placeholder={props.placeholder || ""} maxLength={props.maxLength} />
            {helpBlock}
        </FormGroup>)
}

export default TextInput




// WEBPACK FOOTER //
// ./src/components/common/TextInput.jsx